let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cb445")).then(() => parcelRequire('kF7iq'));